import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import SKUPickListPopup from '../SKU/SKUPickListPopup.js';
import useSKUPalpaAddCheck from '../SKU/useSKUPalpaAddCheck.js';

const SalesOrderDetailItems=({parentId,application,userData,parent,pageTabCallback,refreshToken})=>{
    const list_name='sales_order_items';
    const executeQuery=useRef(true);
    const {checkPalpaBeforeAdd,palpaPopup}=useSKUPalpaAddCheck(application);

    const pageCallback=async(action,args)=>{
        if(action==='invoke_method'){
            if(args.name==='selectRow'){
                checkPalpaBeforeAdd(args.id,()=>pageTabCallback('invoke_method',{name:'add_sku',args:{sku_id:args.id,order_id:parentId}}));//Palpa warning first, then invoke method on parent order to add item and perform all calculations and refresh
            }
        }
        else if(action==='refresh_parent'){
            pageTabCallback('refresh_data');
        }
    }

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        const rawStockOrigin=parent?.stock_origin?.value;
        const isBreweryOrigin=!!rawStockOrigin&&application.globalData.list_of_values_reverse.Stock_Origin?.[rawStockOrigin]==='BREWERY';
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'SalesOrderItem'}
                entityParams={['sales_order_id='+parentId,'_context='+['parent_name=SalesOrder','parent_id='+parentId],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'SalesOrderDetailItems.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                refreshLineAfterFieldUpdate={true}
                refreshParentAfterFieldUpdate={true}
                refreshParentAfterRecordDelete={true}
                popupComponent={SKUPickListPopup}
                popupComponentQuery={isBreweryOrigin?['brewery_stock_filter=Y']:['order_items_filter=Y']}//Transfers: single units with brewery stock
                pageCallback={pageCallback}
                refreshToken={refreshToken}
                parentContext={{
                    parent_field_name:'sales_order_id',
                    parent_field_value:null,
                    parent_name:'SalesOrder'
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name],refreshToken,parent?.stock_origin?.value]);

    return(<>{palpaPopup}{renderListTab}</>);
}
export default SalesOrderDetailItems;